/**
 * Unit-vs-unit attack FX: counter-damage on the attacker slot (return fire).
 */

export function shouldQueueAttackerCounterDamageTrigger(outcome, isGeneralAttack = false) {
  if (isGeneralAttack || !outcome) {
    return false;
  }
  const damageToAttacker = typeof outcome.damageToAttacker === 'number' ? outcome.damageToAttacker : 0;
  return Boolean(
    damageToAttacker > 0
    && outcome.attackerInstanceId
    && typeof outcome.attackerHealthBefore === 'number'
    && typeof outcome.attackerHealthAfter === 'number'
    && outcome.attackerHealthBefore > outcome.attackerHealthAfter
  );
}

export function buildAttackerCounterDamageTrigger({
  attackId,
  outcome,
  attackerZone,
  attackerIndex,
  anchor,
  isGeneralAttack = false,
}) {
  if (!shouldQueueAttackerCounterDamageTrigger(outcome, isGeneralAttack) || !anchor) {
    return null;
  }
  const triggerKey = `${attackId}-attacker-counter`;
  const damageToAttacker = outcome.damageToAttacker;
  return {
    triggerKey,
    payload: {
      attackId: triggerKey,
      x: anchor.x,
      y: anchor.y,
      slotElement: anchor.slotElement,
      rect: anchor.rect,
      timestamp: Date.now(),
      targetZone: attackerZone,
      targetIndex: attackerIndex,
      damageAmount: damageToAttacker,
      targetInstanceId: outcome.attackerInstanceId,
      healthBefore: outcome.attackerHealthBefore,
      healthAfter: outcome.attackerHealthAfter,
    },
  };
}
